export default __webpack_public_path__ + "static/media/Charger1.0eefaccc.png";